import React, { Component } from 'react';
import PropTypes from 'prop-types';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import Button from 'react-bootstrap/lib/Button';
import Icon from './Icon';
import { pickDataAttributes } from '../Util';

export default class InfoTooltip extends Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipPosition: PropTypes.string,
    iconTooltip: PropTypes.string,
    trigger: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)])
  }

  static defaultProps = {
    tooltipPosition: 'left',
    trigger: ['hover', 'focus']
  };

  render() {
    const tooltipClass = this.props.iconTooltip && this.props.iconTooltip === "help" ? "help-tooltip" : "info-tooltip";
    const iClass = this.props.iconTooltip && this.props.iconTooltip === "help" ? "help" : "info";
    const dataAttributes = pickDataAttributes(this.props, 'info-tooltip');
    return (
      <span className="tooltip-container" {...dataAttributes}>
        <OverlayTrigger
          placement={this.props.tooltipPosition}
          trigger={this.props.trigger}
          overlay={<Popover id={"tooltip-"+this.props.name}>{this.props.tooltip}</Popover>}>
          <Button bsStyle="default" className={tooltipClass} aria-label={this.props.label} aria-describedby={this.props.tooltip}>
            <Icon iconType={`${iClass}-outline`}/>
          </Button>
        </OverlayTrigger>
      </span>
    );
  }
}
